module.exports = __webpack_public_path__ + "static/media/logo-sampaio.5591b8f0.png";